<template>
  <div style="padding: 20px; background: #fff" v-if="isShowFooterBtnPanel">
    <template v-for="(item, index) of lastBtnList">
      <el-button
        v-if="!item.disabled"
        :type="item.type"
        :key="index"
        :disabled="item.disabled"
        @click="btnHandler(item.clickName, item.params)"
        class="fixed-bottom-btn"
        >{{ item.title }}
      </el-button>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'FooterBtnGroup',
    props: {
      contractStatus: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        btnList: [
          {
            title: '保存',
            type: 'primary',
            clickName: 'handleSave',
            params: 0,
            key: 'save',
          },
          {
            title: '提交审批',
            type: 'primary',
            clickName: 'handleSave',
            params: 1,
            key: 'approval',
          },
          {
            title: '复制',
            type: 'primary',
            clickName: 'copyHandler',
            key: 'copy',
            params: 'contract',
          },
          {
            title: '关闭合同',
            type: 'danger',
            clickName: 'updateStatusHandler',
            params: 0,
            key: 'close',
          },
          {
            title: '激活合同',
            type: 'primary',
            clickName: 'updateStatusHandler',
            params: 1,
            key: 'activity',
          },
          {
            title: '删除',
            type: 'danger',
            clickName: 'deleteHandler',
            key: 'delete',
          },
          {
            title: '申请撤销',
            type: 'warning',
            clickName: 'updateStatusHandler',
            params: 2,
            key: 'cancel',
          },
          {
            title: '创建提单',
            type: 'primary',
            clickName: 'createBillHandler',
            key: 'create',
          },
          {
            title: '驳回撤销',
            type: 'warning',
            clickName: 'rejectCancelHandler',
            params: 0,
            key: 'rejectCancel',
          },
          {
            title: '确认撤销',
            type: 'primary',
            clickName: 'confirmCancelHandler',
            params: 1,
            key: 'confirmCancel',
          },
        ],
        lastBtnList: [],
        isShowFooterBtnPanel: true,
      };
    },
    methods: {
      // 动态派发事件上去
      btnHandler(clickName, params) {
        this.$emit('btnHandler', clickName, params);
      },
      disabledBtnHandler(contractStatus) {
        this.lastBtnList = this.btnList.map((item) => {
          if (contractStatus == 'ZT06') {
            // 已保存
            if (['save', 'delete', 'approval'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (['ZT02', 'ZT021', 'ZT023', 'ZT024', 'ZT025'].includes(contractStatus)) {
            // 审批中和修订审批中
            return {
              ...item,
              disabled: true,
            };
          } else if (contractStatus == 'ZT03') {
            // 已生效
            if (['copy', 'create', 'cancel', 'close', 'save'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (contractStatus == 'ZT05') {
            // 已驳回
            if (['delete', 'save', 'approval'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (contractStatus == 'ZT07') {
            // 已关闭
            if (['activity'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (['ZT061', 'ZT051'].includes(contractStatus)) {
            // 修订中和修订已驳回
            if (['save', 'approval'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (contractStatus == 'ZT022') {
            // 撤回审批中
            if (['rejectCancel', 'confirmCancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else {
            if (['save', 'approval'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          }
        });
        this.isShowFooterBtnPanel = !this.lastBtnList.every((item) => item.disabled);
      },
    },
    watch: {
      contractStatus: {
        handler(val) {
          console.log(val, '监听到值');
          this.disabledBtnHandler(val);
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
